import React, {useEffect} from 'react'
import {ScrollTop} from '../../../_metronic/layout/components/ScrollTop'
import {Content} from '../../../_metronic/layout/components/Content'
import {PageDataProvider} from '../../../_metronic/layout/core'
import {useLocation} from 'react-router-dom'

import {MenuComponent} from '../../../_metronic/assets/ts/components'
import {AdminAside} from './AdminAside'
import {AdminHeaderWrapper} from './AdminHeaderWrapper'
import {Footer} from '../../../_metronic/layout/components/Footer'

const AdminPortalLayout: React.FC = ({children}) => {
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AdminAside />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <AdminHeaderWrapper />
          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>{children}</Content>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <ScrollTop />
    </PageDataProvider>
  )
}

export {AdminPortalLayout}
